import { atom, useAtom } from 'jotai';

const userIdsAtom = atom('');
const deviceUidAtom = atom<string>('');

export const useUserIdsAtom = () => {
	const [userId, setUserId] = useAtom(userIdsAtom);
	const [deviceUid, setDeviceUid] = useAtom(deviceUidAtom);

	return {
		deviceUid,
		setDeviceUid,
		setUserId,
		userId
	};
};
